import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import axios from '@utils/request'
import { IOneCampaignPayload } from '@app-store/slices/campaigns/oneCampaign'
import { rootActions } from '@app-store/slices'

interface TaskAction extends Action {
    payload: IOneCampaignPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.campaigns.oneCampaign

function* oneCampaignSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/notifications/campaigns/one/${payload.campaignId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(rootActions.ui.emailCampaign.setCampaign(response.result))
            yield put(payload?.sagaCB?.onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* oneCampaignSaga(): any {
    yield takeLatest<TaskAction>(onRequest, oneCampaignSagaTask)
}

export default oneCampaignSaga
